import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class LiabilityStatus extends Enum {
  key!: string;
  value!: string;
  descriptionValue!: string;
  color!: string;
  backgroundColor!: string;

  static TO_BE_PAID: LiabilityStatus = {
    key: 'to_be_paid',
    get value(): string {
      return Lang.t('asset.pending');
    },
    get descriptionValue(): string {
      return Lang.t('asset.pending');
    },
    color: '#F97068',
    backgroundColor: '#F970681A'
  };

  static PAID: LiabilityStatus = {
    key: 'paid',
    get value(): string {
      return Lang.t('billing.paid');
    },
    get descriptionValue(): string {
      return Lang.t('billing.paid');
    },
    color: '#1D9868',
    backgroundColor: '#1D98681A'
  };

  static WAIVED: LiabilityStatus = {
    key: 'waived',
    get value(): string {
      return Lang.t('executor.waived');
    },
    get descriptionValue(): string {
      return Lang.t('executor.waived');
    },
    color: '#EE964B',
    backgroundColor: '#EE964B1A'
  };

  /**
   * @deprecated
   * Deprecated with cashflows V2
   */
  static RECONCILED: LiabilityStatus = {
    key: 'reconciled',
    get value(): string {
      return Lang.t('liability.reconciled');
    },
    get descriptionValue(): string {
      return Lang.t('liability.reconciled');
    },
    color: '#7E84A3',
    backgroundColor: '#7E84A31A'
  };
}
